import { render, staticRenderFns } from "./TotalPointsSpentCard.vue?vue&type=template&id=460198f2&scoped=true"
import script from "./TotalPointsSpentCard.vue?vue&type=script&lang=js"
export * from "./TotalPointsSpentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460198f2",
  null
  
)

export default component.exports